<div class="row">
  <div class="col-auto">

    <!-- Avatar -->
    <div class="avatar avatar-sm">
      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
        <i class="fa fa-bolt"></i>
      </div>
    </div>

  </div>
  <div class="col ms-n2">

    <!-- Heading -->
    <h5 class="mb-1">
      <a routerLink="/calculations/{{event.payload.calculationKeyname}}/{{event.payload.calculationId}}/results">{{ event.titleText }}</a>
    </h5>

    <!-- Text -->
    <p class="small text-gray-700 mb-0">
      {{ event.eventText }}
    </p>

    <p>
      <!-- Time -->
      <small class="text-muted">
        <i class="me-1 fas fa-clock"></i>
        {{ event.lastModifiedText }}
      </small>

      <!-- Calculation Keyname -->
      <small class="text-muted ms-2">
        <i class="me-1 fas fa-calculator-alt"></i>
        {{ getKeynameText(event.payload.calculationKeyname) }}
      </small>

      <!-- User name -->
      <small class="text-muted ms-2">
        <i class="me-1 fas fa-user"></i>
        {{ event.userName }}
      </small>
    </p>

  </div>
</div>